import { render } from "./Loby.vue?vue&type=template&id=b5e4b5a6&scoped=true&ts=true"
import script from "./Loby.vue?vue&type=script&lang=ts"
export * from "./Loby.vue?vue&type=script&lang=ts"

import "./Loby.vue?vue&type=style&index=0&id=b5e4b5a6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e4b5a6"]])

export default __exports__